// src/redux/homePageSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { base_url } from '../../pages/Constants';
// Define the async thunk for fetching data
export const fetchHomePageData = createAsyncThunk(
  'homePage/fetchData',
  async () => {
    const lang  = localStorage.getItem('current_lang') || 'en'; ;
    const response = await axios.get(base_url+'/api/home-page',{
      headers:{
        language:lang
      }
    });
    return response.data; 
  }
);

// Create a slice
const homePageSlice = createSlice({
  name: 'homePage',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHomePageData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchHomePageData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchHomePageData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

// Export the reducer
export default homePageSlice.reducer;
